<template>
  <div>
    <vue-toastr ref="hightlightToast"></vue-toastr>
    <table class="table table-hover">
      <thead>
      <tr>
        <th></th>
        <th>Medientitel</th>
      </tr>
      </thead>
      <draggable v-model="media" group="media" @start="drag=true" @end="updateMediaList" tag="tbody">
        <tr v-for="item in media" :key="media.id" style="cursor:grab;">
          <td style="width: 25px;"><i class="fa fa-bars" aria-hidden="true"></i></td>
          <td>{{ item.title }}</td>
        </tr>
      </draggable>
    </table>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import VueToastr from "vue-toastr";

export default {
  name: 'FmuHighlights',
  components: {draggable, VueToastr},
  props: ['media'],
  methods: {
    updateMediaList() {
      axios.post('/api/fmu/highlights/reorder', {
        media: this.media
      }).then(() => {
        this.$refs.hightlightToast.s("Neue Sortierung gespeichert", "Erfolgreich");
      }).catch(() => {
        this.$refs.hightlightToast.e("Bitte versuche es noch einmal.", "Fehler");
      })
    }
  }
}
</script>

<style scoped>
</style>
